export default [
  {
    title: 'تسويق',
    items: [
      'إدارة التسويق',
      'جلسات تصوير',
      'إدارة الخدمات الإعلانية'
    ],
    slug: ''
  },
  {
    title: 'تصميم',
    items: [
      'طباعة',
      'تصميم غرافيكس',
      'صناعة علامة تجارية'
    ],
    slug: ''
  },
  {
    title: 'تصوير',
    items: [
      'تصوير إعلانات',
      'تصوير منتجات',
      'تصوير مناسبات'
    ],
    slug: ''
  },
  {
    title: 'فيديو',
    items: [
      'غرافيكس',
      'إعلانات',
      'تحريك كرتون'
    ],
    slug: ''
  }//,
  // {
  //   title: 'برمجة',
  //   items: [
  //     'تصميم مواقع',
  //     'تصميم تطبيقات',
  //     'حلول تقنية',
  //   ],
  //   slug: ''
  // },
]
